import { Polymath } from '@polymathnetwork/sdk';

export const polyClient = new Polymath();
